import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {


  url = environment.serverAPI6 + "/api/accounts";

  url1 = environment.serverAPI4 + "/api/account";

    url2 = environment.serverAPI4 + "/api";

  constructor(private http: HttpClient) { }

  getAllAccounts(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllAccountsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getAccountsById(accountId: number): Observable<Object> {
    return this.http.get(`${this.url}/${accountId}`);
  }

  addOrEditAccounts(accounts: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, accounts);
  }

  AccountsSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByAccountId(accountId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${accountId}`);
  }

  getAllAccountsBYtenant(): Observable<Object> {
    return this.http.get(`${this.url1}/details`);
  }



    getAlSubcriptionDetails(): Observable<Object> {
  // Use live account details so renewal screens reflect the latest subscribed plan.
   return this.http.get(`${this.url1}/details`);
  }


}
